
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  HostBinding,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SCROLLABLE_DIRECTION_TOKEN, SCROLLABLE_HTMLELEMENT_TOKEN } from '../../utils';

export const scrollAmount = 30;

@Component({
  selector: 'app-scolling-button',
  templateUrl: './scrolling-button.component.html',
  styleUrls: ['./scrolling-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollingButtonComponent implements OnInit, OnDestroy, DoCheck {
  
  private scrollInterval: any;
  private disabledPrevResult: boolean;

  @HostBinding('class')
  private direction: 'left' | 'right';

  get isScrollDisabled(): boolean {
    const element = this.scrollableHTMLElement;
    return (
      (this.direction === 'left' && element.scrollLeft === 0) ||
      (this.direction === 'right' && element.scrollLeft + element.clientWidth >= element.scrollWidth)
    );
  }

  constructor(
    @Inject(SCROLLABLE_DIRECTION_TOKEN) private directInject: 'left' | 'right',
    @Inject(SCROLLABLE_HTMLELEMENT_TOKEN) private scrollableHTMLElement: HTMLElement,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.direction = this.directInject;
  }

  ngDoCheck(): void {
    const disabledCalc = this.isScrollDisabled;
    if (this.disabledPrevResult !== disabledCalc) {
      this.disabledPrevResult = disabledCalc;
      this.cd.detectChanges();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.scrollInterval);
    
  }

  @HostListener('click')
  private onClickHandler(): void {
    this.scroll();
  }

  @HostListener('mousedown')
  private onMouseDown(): void {
    this.scrollInterval = setInterval(() => {
      this.scroll();
    }, 100);
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  private onMouseUpOrLeave(): void {
    clearInterval(this.scrollInterval);
  }

  private scroll(): void {
    const element = this.scrollableHTMLElement;

    if (this.direction === 'left') {
      element.scrollLeft -= scrollAmount;
    } else if (this.direction === 'right') {
      element.scrollLeft += scrollAmount;
    }

    this.cd.detectChanges();
    this.cd.markForCheck();
  }
}
